
const rateWithCritical = (name, title, questions=[], comment=false) => {
    const result = {
        type: 'matrixdropdown',
        name: name,
        title: title,
        columns: [
            {
                name: 'range',
                cellType: 'radiogroup',
                showInMultipleColumns: true,
                // isRequired: true,
                maxWidth: '100px',
                choices: [
                    'Not Important',
                    'Somewhat Important',
                    'Very Important'
                ]
            },
            {
                name: 'critical',
                cellType: 'boolean',
                title: 'Non-Negotiable',
                valueTrue: 'yes',
                valueFalse: 'no',
                width: '12rem' // dumb dumbs!
            }
        ],
        rows: [...questions]
    }
    if(comment) {
        result.columns.push(
            {
                name: "comment",
                title: "Please comment",
                cellType: "comment"
            }
        )
    }
    return result;
}

export const htmlElement = (text) => {
    return {
        type: 'html',
        html: text
    }
}

const commentElement = (name, title) => {
    return {
        type: 'comment',
        name: name,
        title: title,
        autoGrow: true
    }
}

const rateWithCriticalInstructions = () => {
    return htmlElement(`
        <p>For each item below, please indicate the scale of your answer, from "not important" to "very important".</p>
        <p>Optionally, if an item is non-negotiable, please indicate so and the agency will prioritize this preference.</p>
        <br />
        <p><i>Please note all non-negotiable items may be subject to interpretation by adoptive Big(s).</i></p>`
    );
}

const option = (val, text) => {
    return {
        value: val,
        text: text
    }
}

const survey = {
    firstPageIsStarted: true,
    showPreviewBeforeComplete: 'showAllQuestions',
    pages: [
        {
            title: 'Legal Notice',
            elements: [
                htmlElement(`
                    <p>
                        By completion of this form, you agree to the sharing of personal information with BIG LITTLE HEARTS, TL, subject to Alliance Littles Data Protection (ALDP) and Interdimensional Transmission Privacy (ITP) laws.
                    </p>
                    <br />
                    <p>
                        This form does not constitute an Adoption Agreement, nor any kind of binding contract between Little and Big(s).
                    </p>
                `)
            ]
        },
        {
            title: 'Preferred Age Characteristics',
            elements: [
                htmlElement(`
                    <p>
                        This section discusses your preferences regarding what age you would prefer to live as under your adoption in Tulna. This includes not just physical characteristics, but also mental and physical abilities.
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('age','I wish to be treated as a/an', [
                    option('targetNewborn', 'Newborn (0-6 months)'),
                    option('targetInfant', 'Infant (6-12 months)'),
                    option('targetToddler', 'Toddler (1-3 years)'),
                    option('targetAdolescent', 'Adolescent (4+ years)')
                ]),
                rateWithCritical('appearance','I wish for my appearance', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('physicalAbility','I wish for my physical abilities', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('mentalAbility','I wish for my mental abilities', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('speechPattern','I wish for my pattern of speech', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('voice','I wish for my voice', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('teeth','I wish for my teeth', [
                    option('targetExactly', 'to resemble my target age'),
                    option('targetYounger', 'to resemble younger than my target age'),
                    option('targetUnchanged', 'to be unchanged')
                ]),
                rateWithCritical('memories','I wish for my memories', [
                    option('memoryClear', 'to be erased completely'),
                    option('memoryPositiveOnly', 'to only retain happy memories'),
                    option('memoryUnchanged', 'to be unchanged')
                ]),
                
            ]
        },
        {
            title: 'Preferred Gender Characteristics',
            elements: [
                htmlElement(`
                    <p>
                        The following section considers your gender-related characteristics.
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('gender','I wish to be treated as', [
                    option('male', 'Male'),
                    option('female', 'Female')
                ]),
                rateWithCritical('genderPhysical','I wish for my physical body', [
                    option('genderPhysicalMatch', 'to match my gender'),
                    option('genderPhysicalUnchanged', 'to be unchanged'),
                    option('genderPhysicalComments', 'Other (comment in the next question)')
                ]),
                commentElement('genderPhysicalComment', 'Other comments on your physical body?')
            ]
        },
        {
            title: 'Medical Conditions',
            elements: [
                htmlElement(`
                    <p>
                        This section concerns medical conditions you may wish to be addressed before or during your adoption in Tulna. 
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('medicalCondition','I wish for medical treatment of the following', [
                    option('dental', 'Dental'),
                    option('eyesight', 'Eyesight'),
                    option('pain', 'Chronic Pain'),
                    option('deformities', 'Skin lesions / physical deformities'),
                    option('foundOnExamination', 'Any issues found upon examination'),
                    option('other', 'Other (comment in the next question)')
                ]),
                commentElement('medicalConditionOther', 'Other comments on your medical condition?')
            ]
        },
        {
            title: 'Family Characteristics',
            elements: [
                htmlElement(`
                    <p>
                        This section concerns family environment and dynamics, for example parenting styles, siblings, other Littles, etc.
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('familyComposition','I wish to live with', [
                    option('mother', 'A mother'),
                    option('father', 'A father'),
                    option('siblings', 'Siblings'),
                    option('littles', 'Other Littles'),
                    option('other', 'Other (comment in the next question)')
                ]),
                commentElement('familyCompositionOther', 'Other comments on who you wish to live with?'),
                rateWithCritical('parentingStyle','I prefer a parenting style that is', [
                    option('authoritarian', 'Authoritarian'),
                    option('balanced', 'Balanced'),
                    option('permissive', 'Permissive'),
                ]),
                rateWithCritical('familyLifestyle','I prefer a family that has a', [
                    option('relgious', 'Religious lifestyle'),
                    option('physicallyActive', 'Physically active lifestyle'),
                ]),
            ]
        },
        {
            title: 'Environment Characteristics',
            elements: [
                htmlElement(`
                    <p>
                        This section concerns your day-to-day life environment, e.g. where you will live, what activities you enjoy, etc.
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('location','I wish to live in/near', [
                    option('city', 'A city'),
                    option('town', 'A small town'),
                    option('suburbs', 'Suburbs'),
                    option('country', 'the country'),
                    option('other', 'Other (comment in the next question)')
                ]),
                commentElement('locationOther', 'Other comments on where you wish to live in/near?'),
                rateWithCritical('daytimeActivity','I wish to', [
                    option('home', 'Stay home'),
                    option('daycare', 'Attend daycare'),
                    option('preschool', 'Attend preschool'),
                    option('school', 'Attend school')
                ]),
                rateWithCritical('toys','I prefer toys/activities that', [
                    option('physical', 'Physically engage me'),
                    option('mental', 'Mentally engage me'),
                    option('emotional', 'Emotionally engage me')
                ]),
                {
                    type: 'text',
                    name: 'favoriteColor',
                    title: 'I prefer colors that are... (specify)'
                }
            ]
        },
        {
            title: 'Before/After Adoption',
            elements: [
                htmlElement(`
                    <p>
                        This section concerns logistical items before and after adoption in Tulna.
                    </p>
                `),
                rateWithCriticalInstructions(),
                rateWithCritical('afterAdoption','After adoption, I wish to', [
                    option('growUp', 'Grow up to a specified age'),
                    option('growDown', 'Never grow up'),
                    option('keepFirstName', 'Retain my first name')
                ]),
                commentElement('growUpOther', 'Other comments on growing up?'),
                rateWithCritical('beforeAdoption','Until adoption, I wish to', [
                    option('suspendedAnimation', 'Be placed in suspended animation'),
                    option('continueAsNormal', 'Continue living my life as normal')
                ])
            ]
        }
    ]
};

export default survey;